import { jaDashboard } from '~/src/locales/ja/dashboard';
import { jaMetrics } from '~/src/locales/ja/metrics';
import { jaCommon } from '~/src/locales/ja/common';
import { jaDatetime } from '~/src/locales/ja/datetime';
import { jaBidders } from '~/src/locales/ja/bidders';
import { jaChannels } from '~/src/locales/ja/channels';
import { jaReporting } from '~/src/locales/ja/reporting';
import { jaBrandSafety } from '~/src/locales/ja/brandSafety';
import { jaBrandsDashboard } from '~/src/locales/ja/brandsDashboard';
import { jaDeals } from '~/src/locales/ja/deals';

export const jaTranslation = {
  translation: {
    // by view
    ...jaBidders,
    ...jaBrandsDashboard,
    ...jaBrandSafety,
    ...jaChannels,
    ...jaDashboard,
    ...jaReporting,
    // by common
    ...jaCommon,
    ...jaDeals,
    ...jaDatetime,
    ...jaMetrics,
  },
};
